import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/element.js'

import './assets/css/oneoneBootstrap.css'
import './assets/css/bootstrap.min.css'
import request from "@/assets/js/axios";
import all from "@/assets/js/all";

Vue.prototype.$axios = request;
Vue.prototype.$all = all;

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
